export const fadeSliderOptions = {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,

  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

export const tabsSliderOptions = {
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  centeredSlides: true,
  spaceBetween: 16,

  breakpoints: {
    1001: {
      centeredSlides: false,
    },
  },
};

export const tabsContentSliderOptions = {
  slidesPerView: 1,
  slideToClickedSlide: true,
  simulateTouch: false,
  autoHeight: true,

  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },

  thumbs: {
    swiper: null,
    autoScrollOffset: 0.5,
  },
};

export const innerSliderOptions = {
  slidesPerView: 1,
  nested: true,
  slideToClickedSlide: true,

  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};
